import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { ButtonPurpose } from './button-purpose';
import { ButtonType } from './button-type';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'button[app-button]',
    templateUrl: './appButton.html',
    styleUrls: ['./appButton.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppButtonComponent {
  @HostBinding('attr.aria-checked')
  _checked: boolean | null = null;

  @HostBinding('attr.aria-expanded')
  @Input()
  ariaExpanded: boolean | null = null;

  @HostBinding('attr.class')
  get btnClasses() {
    return [
      'btn',
      'ngx-shared',
      this.purpose,
      this.enableLight ? 'btn-secondary-light' : '',
      this._checked ? 'active' : '',
      this.class,
    ]
      .filter(Boolean)
      .join(' ');
  }

  @HostBinding('attr.role')
  _role: 'switch' | null = null;

  @HostBinding('attr.type')
  @Input()
  type = ButtonType.Button;

  @Input()
  class = '';

  @Input()
  enableLight = false;

  @Input()
  purpose: ButtonPurpose | `${ButtonPurpose}` = ButtonPurpose.Primary;

  @Input()
  set checked(value: boolean | null) {
    this._checked = value;

    if (typeof value === 'boolean') {
      this._role = 'switch';
    } else {
      this._role = null;
    }
  }
}
